var render = function render(){var _vm=this,_c=_vm._self._c;return _c('qrcode-vue',{attrs:{"value":_vm.value,"size":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }